import { createTelemetryClient, registerGlobalErrorHandlers } from '@klareospace/pharos-lib-web-utils';
import { version } from '../../package.json';
import { env } from '&/config';

/**
 * Application Insights telemetry singleton for the frontoffice app.
 *
 * When VITE_APPINSIGHTS_CONNECTION_STRING is empty (local dev), a no-op client
 * is returned — no network calls, no errors, no console noise.
 */
export const telemetryClient = createTelemetryClient({
  appName: 'frontoffice',
  appVersion: version,
  connectionString: env.appInsightsConnectionString,
  environment: import.meta.env.MODE,
});

// Register window-level error handlers (idempotent — safe if called more than once).
registerGlobalErrorHandlers(telemetryClient);
